import type { RuleDefinition, RuleFinding } from '../domain/types';
import { getCellText } from '../domain/cells';
import { normalizeTextForComparison, normalizeUnit } from '../utils/text';
import { finding, groupRows } from './helpers';

export const BQ011: RuleDefinition = {
  id: 'BQ011',
  name: '同名称和特征的单位不一致',
  description: '仅在同一工作表内比较规范化后名称和项目特征相同的明细。',
  defaultSeverity: 'warning',
  enabled: true,
  applicableFields: ['name', 'description', 'unit'],
  message: '相同项目名称和项目特征使用了不同计量单位。',
  suggestion: '请结合原清单口径核对计量单位；同义单位写法由 BQ012 单独提示。',
  check: ({ detailRows }) => {
    const results: RuleFinding[] = [];
    const groups = groupRows(detailRows, (row) => {
      const name = normalizeTextForComparison(getCellText(row, 'name'));
      const description = normalizeTextForComparison(getCellText(row, 'description'));
      return name.length === 0 || description.length === 0 ? '' : `${name}\u001f${description}`;
    });
    groups.forEach((rows) => {
      const firstByUnit = new Map<string, number>();
      [...rows]
        .sort((left, right) => left.excelRow - right.excelRow)
        .forEach((row) => {
          const unit = normalizeUnit(getCellText(row, 'unit'));
          if (unit.length === 0 || firstByUnit.has(unit)) return;
          const relatedRows = [...firstByUnit.values()];
          firstByUnit.set(unit, row.excelRow);
          if (relatedRows.length === 0) return;
          results.push(
            finding(row, 'unit', {
              currentValue: getCellText(row, 'unit'),
              relatedRows,
              message: `相同名称和特征在第 ${relatedRows.join('、')} 行使用了不同计量单位。`,
            }),
          );
        });
    });
    return results;
  },
};
